export const FORMULA_EDITOR_CONTENT = "FORMULA_EDITOR_CONTENT";
export const FORMULA_EDITOR_DASHBOARD_VARIABLES = "FORMULA_EDITOR_DASHBOARD_VARIABLES";

/**
 * 
 * @param contentObject 
 * @returns 
 * 
 * Sets Formula Editor content
 */
export const setFormulaEditorContent = (contentObject) => {
  return (dispatch) => {
    dispatch({
      type: FORMULA_EDITOR_CONTENT,
      payload: contentObject,
    });
  };
}

/**
 * 
 * @param dashboardVariables 
 * @returns 
 * 
 * Sets Dashboard Variables for Formula Editor
 */
export const setDashboardVariables = (dashboardVariables) => {
  return (dispatch) => {
    dispatch({
      type: FORMULA_EDITOR_DASHBOARD_VARIABLES,
      payload: dashboardVariables,
    });
  };
}
